import Form from 'components/Form';
import MuiTextField from 'components/Form/MuiTextField';
import RowContainer from '../../components/RowContainer';
import RowContent from '../../components/RowContent';

import { IPatientInfo } from 'apis/admin/type';
import { IFormRegister } from 'routes/Main/type';

interface Props extends IFormRegister {
  disabled?: boolean;
  nurseName: string;
  patientInfo: IPatientInfo;
}

const PatientStaffInfo = (props: Props) => {
  const {
    patientInfo: {
      patient_id,
      name,
      age,
      gender,
      ward,
      room,
      admin_hod,
      department,
      disease_main,
      height,
      weight,
      blood,
    },
    register,
    disabled,
  } = props;

  const infos = [
    { title: 'Tên bệnh nhân', value: name },
    { title: 'Mã số đăng ký', value: patient_id },
    { title: 'Tuổi', value: age },
    { title: 'Giới tính', value: gender },
    { title: 'Khu vực', value: ward },
    { title: 'Phòng', value: room },
    { title: 'Khoa điều trị ', value: department },
    { title: 'HOD', value: admin_hod },
    { title: 'Chiều cao', value: height },
    { title: 'Cân nặng', value: weight },
    { title: 'Nhóm máu', value: blood },
    { title: 'Chẩn đoán', value: disease_main.disease_eng },
  ];

  const staffs = [
    {
      title: 'Bác sĩ phẫu thuật',
      variable: 'surgery_information.operating_surgeon',
    },
    { title: 'Trợ lý', variable: 'surgery_information.assistant' },
    {
      title: 'Y tá phòng mổ',
      variable: 'surgery_information.scrubbing_nurse',
    },
    {
      title: 'Y tá  lưu động',
      variable: 'surgery_information.circulating_nurse',
    },
  ];

  return (
    <RowContainer xs={12}>
      {infos.map(({ title, value }) =>
        title === 'Gender' ? (
          <RowContent title={title} titleRatio={1} childrenRatio={2}>
            <Form.MuiRadioGroup
              i18nKey="GENDER"
              values={[1, 2]}
              value={Number(value)}
              defaultValue={Number(value)}
            />
          </RowContent>
        ) : (
          <RowContent title={title} titleRatio={1} childrenRatio={2}>
            <Form.MuiTextField value={value} InputProps={{ readOnly: true }} />
          </RowContent>
        )
      )}

      {staffs.map(({ title, variable }, _) => {
        return (
          <RowContent
            key={variable}
            title={title}
            titleRatio={1}
            childrenRatio={2}
          >
            <MuiTextField
              {...register(variable)}
              required={false}
              disabled={disabled}
            />
          </RowContent>
        );
      })}
    </RowContainer>
  );
};

export default PatientStaffInfo;
